// Polyfills for IE11; must be loaded first
import 'core-js/features/array/includes';
import 'core-js/features/string/includes';
import 'core-js/features/string/starts-with';
import 'core-js/features/object/values';
import 'core-js/features/object/keys';
import eventSource from 'event-source-polyfill'; // eslint-disable-line no-unused-vars
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import store, { history } from './store';
import AppContainer from './components/App/AppContainer';

import './index.css';

const target = document.querySelector('#root');

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppContainer />
    </ConnectedRouter>
  </Provider>,
  target,
);
